var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-drag",attrs:{"id":"testDrag"},on:{"touchstart":_vm.dragStart,"touchmove":_vm.dragMove,"touchend":_vm.dragEnd}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }